/**
 * Drawer for cart extended from generic drawer element
 */
import Drawer from './drawer';

class DrawerCart extends Drawer {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    openDrawer() {
        setTimeout(() => {
            document.body.classList.add('cart-drawer--visible');
        }, 50);
        super.openDrawer()
    }

    closeDrawer() {
        setTimeout(() => {
            document.body.classList.remove('cart-drawer--visible');
        }, 300);
        super.closeDrawer()
    }

    bindEvents() {
        document.addEventListener('theme:drawer:cart:update', (e) => {
            this.fetchCartContent();
        });

        document.addEventListener('theme:drawer:cart:open', (e) => {
            this.openDrawer();
        });

        super.bindEvents()
    }
}

customElements.define('drawer-cart', DrawerCart);